import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchUser } from "../slices/userSlice";

export const useProfile = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const user = useSelector((state) => state.user.data);

    useEffect(() => {
        dispatch(fetchUser({token}));
    }, [dispatch, token]);

    return { user }
}